import React, { useState, useRef, useContext } from 'react';
import {
  Search, CheckCircle, DollarSign, Star, X, Send,
  Wrench, ChevronDown, UserCog
} from 'lucide-react';
import { Mic, MicOff, ImagePlus, X as XIcon } from 'lucide-react';
import AppContext from '../../../../../context/AppContext';

// Post Job Modal
const PostJobModal = ({ onClose, onSubmit, customers = [], workers = [], categories = [], loading}) => {
  const {baseUrl} = useContext(AppContext);
  const [jobTitle, setJobTitle] = useState('');
 const [whcategory_id, setWhCategoryId] = useState('');
  const [budget, setBudget] = useState('');
  const [address, setAddress] = useState('');
  const [deadline, setDeadline] = useState('');
  const [description, setDescription] = useState('');
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [selectedWorker, setSelectedWorker] = useState(null);
  const [fullName,    setFullName]    = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email,       setEmail]       = useState('');

  const [mediaFiles, setMediaFiles] = useState([]);
  const [isListening, setIsListening] = useState(false);
  const [voiceStatus, setVoiceStatus] = useState('');

  // Dropdown states
  const [showCustomerDrop, setShowCustomerDrop] = useState(false);
  const [showWorkerDrop, setShowWorkerDrop] = useState(false);
  const [customerSearch, setCustomerSearch] = useState('');
  const [workerSearch, setWorkerSearch] = useState('');

  const recognitionRef = useRef(null);

  /* =========================
      VOICE FUNCTION
  ========================== */
  const startVoice = () => {

    const SpeechRecognition =
      window.SpeechRecognition ||
      window.webkitSpeechRecognition;

    if (!SpeechRecognition) {
      setVoiceStatus('Voice not supported');
      return;
    }

    if (isListening) {
      recognitionRef.current?.stop();
      setIsListening(false);
      setVoiceStatus('');
      return;
    }

    const recognition = new SpeechRecognition();

    const minDateTime = new Date();
minDateTime.setMinutes(minDateTime.getMinutes() - minDateTime.getTimezoneOffset());

<input
  type="datetime-local"
  value={deadline}
  min={minDateTime.toISOString().slice(0,16)}
  onChange={(e)=>setDeadline(e.target.value)}
/>
    recognitionRef.current = recognition;

    recognition.lang = 'en-US';
    recognition.continuous = true;
    recognition.interimResults = false;

    recognition.onstart = () => {
      setIsListening(true);
      setVoiceStatus('Listening...');
    };

    recognition.onresult = (event) => {

      const transcript = Array.from(event.results)
        .map(r => r[0].transcript)
        .join(' ')
        .toLowerCase();

      const titleMatch = transcript.match(
        /title\s+(.+?)(?=\s+category|\s+budget|\s+location|\s+date|\s+description|$)/i
      );

      if (titleMatch) {
        setJobTitle(titleMatch[1].trim());
      }

      const budgetMatch = transcript.match(/budget\s+(\d+)/i);

      if (budgetMatch) {
        setBudget(budgetMatch[1]);
      }

      setVoiceStatus('Voice captured');
    };

    recognition.onerror = (e) => {
      setVoiceStatus(e.error);
      setIsListening(false);
    };

    recognition.onend = () => {
      setIsListening(false);
    };

    recognition.start();
  };

  /* =========================
      MEDIA FUNCTIONS
  ========================== */

  const handleMediaFiles = (e) => {

    const files = Array.from(e.target.files).map(f => ({
      file: f,
      url: URL.createObjectURL(f),
      type: f.type.startsWith('video') ? 'video' : 'image',
      name: f.name,
    }));

    setMediaFiles(prev => [...prev, ...files]);
  };

  const removeMedia = (index) => {

    setMediaFiles(prev =>
      prev.filter((_, i) => i !== index)
    );
  };

  /* =========================
      SUBMIT
  ========================== */

const handleSubmit = (e) => {
  e.preventDefault();

onSubmit({
  jobTitle,
  whcategory_id,
  fullName,
  phoneNumber,
  email,
  budget: Number(budget),
  address,
  deadline,
  description,
  mediaFiles,
  customer: selectedCustomer,
  worker: selectedWorker,
});
};

  // Filtered lists
const filteredCustomers = customers.filter(c =>
  c?.fullName?.toLowerCase().includes(customerSearch.toLowerCase()) ||
  c?.email?.toLowerCase().includes(customerSearch.toLowerCase()) ||
  c?.phoneNumber?.toLowerCase().includes(customerSearch.toLowerCase())
);

const filteredWorkers = workers.filter(w =>
  (w?.fullName || '').toLowerCase().includes(workerSearch.toLowerCase()) ||
  (w?.selectservice || '').toLowerCase().includes(workerSearch.toLowerCase())
);

  return (
    <div className="sj-modal-overlay" onClick={onClose}>
      <div className="sj-modal" onClick={e => e.stopPropagation()}>
        <button className="sj-modal__close" onClick={onClose}>
          <X size={20} />
        </button>

        <div className="sj-modal__header">
          <Wrench size={22} className="sj-modal__icon" />
          <div>
            <h2 className="sj-modal__title">Post a New Job</h2>
            {/* <p className="sj-modal__subtitle">Fill in job details, pick a customer & assign the right worker.</p> */}
          </div>
        </div>

        <form onSubmit={handleSubmit} className="sj-form">
          {/* Job Details Section */}
          <div className="sj-form-section">
              <div className="sj-form-row">
              <div className="sj-form-field">
                <label>full Name </label>
                <input
                  type="text"
                  placeholder="Full Name"
                  value={fullName}
                  onChange={e => setFullName(e.target.value)}
                  required
                />
              </div>
              <div className="sj-form-field">
                <label>Email</label>
                <input
                  type="email"
                  placeholder="Email"
                  value={email}
                  onChange={e => setEmail(e.target.value)}
                />
              </div>
              
            </div>
            <div className="sj-form-row">
              <div className="sj-form-field">
                <label>phone</label>
                <input
                  type="text"
                     placeholder="Phone Number"
                  value={phoneNumber}
                  onChange={e => setPhoneNumber(e.target.value)}
                  required
                />
              </div>
             
              
            </div>
            
            {/* <h3 className="sj-form-section__title">📋 Job Details</h3> */}
            
            <div className="sj-form-field">
              <label>Job Title *</label>
              <input
                type="text"
                placeholder="e.g. Full house electrical wiring"
                value={jobTitle}
                onChange={e => setJobTitle(e.target.value)}
                required
              />
            </div>

            <div className="sj-form-row">
              <div className="sj-form-field">
                <label>Category *</label>
    <select
  value={whcategory_id}
  onChange={(e) => setWhCategoryId(e.target.value)}
  required
>
  <option value="">Select Category</option>

  {categories.map((cat) => (
    <option key={cat.id} value={cat.id}>
      {cat.categoryName}
    </option>
  ))}
</select>
              </div>

              <div className="sj-form-field">
                <label>Budget *</label>
                <input
                  type="number"
                  placeholder="$120"
                  value={budget}
                  onChange={e => setBudget(e.target.value)}
                  required
                />
              </div>
            </div>

            <div className="sj-form-row">
              <div className="sj-form-field">
                <label>Date *</label>
                <input
  type="datetime-local"
  value={deadline}
  min={new Date().toISOString().slice(0,16)}
  onChange={(e)=>setDeadline(e.target.value)}
/>
              </div>
              <div className="sj-form-field">
                <label>Location</label>
                <input
                  type="text"
                  placeholder="Street, City"
                  value={address}
                  onChange={e => setAddress(e.target.value)}
                />
              </div>
              
            </div>
          

            

            <div className="sj-form-field">
              <label>Description</label>
              <textarea
                placeholder="Describe the job, scope, materials, etc."
                value={description}
                onChange={e => setDescription(e.target.value)}
                rows={3}
              />
            </div>

            <div className="sj-form-field">
              <label>Media (Photos / Videos)</label>
              <label className="sj-media-upload-area">
                <ImagePlus size={20} className="sj-media-upload-area__icon"/>
                <span>Tap to add photos or videos</span>
                <span className="sj-media-upload-area__hint">JPG, PNG, MP4, MOV</span>
                <input
                  type="file"
                  accept="image/*,video/*"
                  multiple
                  style={{ display: 'none' }}
                  onChange={handleMediaFiles}
                />
              </label>
              {mediaFiles.length > 0 && (
                <div className="sj-media-preview">
                  {mediaFiles.map((m, i) => (
                    <div key={i} className="sj-media-thumb">
                      {m.type === 'video'
                        ? <video src={m.url} className="sj-media-thumb__img"/>
                        : <img src={m.url} alt={m.name} className="sj-media-thumb__img"/>
                      }
                      <button
                        type="button"
                        className="sj-media-thumb__del"
                        onClick={() => removeMedia(i)}
                      >
                        <XIcon size={11}/>
                      </button>
                    </div>
                  ))}
                </div>
              )}
            </div>

          </div>

          

          {/* Assign Worker Section */}
          <div className="sj-form-section">
            <h5 className="sj-form-section__title">
              <UserCog size={16} /> Assign Worker
            </h5>
            <div className="sj-dropdown-wrap">
              <div
                className={`sj-dropdown-trigger${showWorkerDrop ? ' sj-dropdown-trigger--open' : ''}${selectedWorker ? ' sj-dropdown-trigger--selected' : ''}`}
                onClick={() => { setShowWorkerDrop(!showWorkerDrop); setShowCustomerDrop(false); }}
              >
                <span>{selectedWorker ? selectedWorker.fullName : 'Search & assign worker...'}</span>
                <ChevronDown size={16} />
              </div>

              {showWorkerDrop && (
                <div className="sj-dropdown-panel">
                  <div className="sj-dropdown-search">
                    <Search size={14} />
                    <input
                      autoFocus
                      placeholder="Type name or category..."
                      value={workerSearch}
                      onChange={e => setWorkerSearch(e.target.value)}
                    />
                  </div>
                  <div className="sj-dropdown-list">
                    {filteredWorkers.map(worker => (
                      <div
                        key={worker.id}
                        className={`sj-dropdown-item${selectedWorker?.id === worker.id ? ' sj-dropdown-item--active' : ''}`}
                        onClick={() => {
                          setSelectedWorker(worker);
                          setShowWorkerDrop(false);
                          setWorkerSearch('');
                        }}
                      >
                        <div className="sj-job-profile__avatar sj-job-profile__avatar--worker">
                          {worker.fullName.split(' ').map(n => n[0]).join('')}
                        </div>
                        <div className="sj-dropdown-item__info">
                          <span className="sj-dropdown-item__name">{worker.fullName}</span>
                          <span className="sj-dropdown-item__sub">
                            <Star size={10} fill="#f59e0b" color="#f59e0b" /> {worker.rating} · {worker.selectservice} · {worker.jobs} jobs
                          </span>
                        </div>
                        {selectedWorker?.id === worker.id && (
                          <CheckCircle size={16} className="sj-dropdown-item__check" />
                        )}
                      </div>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>

          {/* Submit Button */}
          <div className="sj-form-actions">
            <button type="button" className="sj-btn sj-btn--cancel" onClick={onClose}>
              Cancel
            </button>
          <button
  type="submit"
  className="sj-btn sj-btn--submit"
  disabled={loading}
>
  {loading ? (
    <>
      <div className="sj-btn-spinner"></div>
      Posting...
    </>
  ) : (
    <>
      <Send size={16} />
      Post & Assign
    </>
  )}
</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PostJobModal;